import { render, staticRenderFns } from "./tripDetail.vue?vue&type=template&id=2865dc68&"
import script from "./tripDetail.vue?vue&type=script&lang=js&"
export * from "./tripDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports